import Layout from '../components/layouts';
import Dashboard from '../components/dashboard/DashboardPage';

DashboardPage.getLayout = function getLayout(children: React.ReactNode) {
  return (
    <Layout title="Home" variant="dashboard-new" containerSxProps={{ paddingX: '0px !important' }}>
      {children}
    </Layout>
  );
};

export default function DashboardPage() {
  return <Dashboard />;
}
